/* eslint-disable */
import React from 'react';
import './DssModal.css';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}><i class="fa fa-close"></i></button>
                {children}
            </div>
        </div>
    );
};

export default Modal;

